"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CustomerNotification;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _client = _interopRequireDefault(require("@sart/client"));
var _content = require("@sart/content");
var _utilities = require("@sart/utilities");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var formatDate = function formatDate(date, language) {
  if (date && date !== null) {
    var languageCode = (0, _utilities.getLanguageCode)(language);
    var formatted = (0, _moment["default"])(date).utc().locale(languageCode).format('ddd D MMM');
    var elements = formatted.split('.').join('').split(' ');
    elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
    elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
    return elements.join(' ');
  }
  return null;
};
function CustomerNotification(props) {
  var notification = props.notification,
    disabled = props.disabled,
    language = props.language,
    markAsRead = props.markAsRead,
    displayNotification = props.displayNotification;
  var content = (0, _content.useContent)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    titleNeedsExtending = _useState4[0],
    setTitleNeedsExtending = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    textNeedsExtending = _useState6[0],
    setTextNeedsExtending = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    titleLines = _useState8[0],
    setTitleLines = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState0 = (0, _slicedToArray2["default"])(_useState9, 2),
    textLines = _useState0[0],
    setTextLines = _useState0[1];
  var onTitleTextLayout = (0, _react.useCallback)(function (f) {
    if (titleLines == 0) {
      setTitleLines(f.nativeEvent.layout.height);
      if (f.nativeEvent.layout.height > 32) {
        setTitleNeedsExtending(true);
      }
    }
  });
  var onTextLayout = (0, _react.useCallback)(function (e) {
    if (textLines == 0) {
      setTextLines(e.nativeEvent.layout.height);
      if (e.nativeEvent.layout.height > 29) {
        setTextNeedsExtending(true);
      }
    }
  });
  function getNotificationType(notificationTags) {
    if (notificationTags !== undefined && notificationTags.length > 0) {
      return notificationTags.find(function (t) {
        return t.tag !== null;
      }).tag;
    } else {
      return '';
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: styles.container,
    onPress: displayNotification,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.productImage
  }, getNotificationType(notification.tags) === 'ANNOUNCEMENT' && /*#__PURE__*/_react["default"].createElement(_icons.Announcement, null), getNotificationType(notification.tags) === 'QUESTIONNAIRE' && /*#__PURE__*/_react["default"].createElement(_icons.Questionnaire, null), getNotificationType(notification.tags) === 'PROMOTION' && /*#__PURE__*/_react["default"].createElement(_icons.Promotion, null)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.body
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.header,
    onLayout: onTitleTextLayout,
    numberOfLines: titleLines == 0 ? null : showMore ? 0 : 2,
    ellipsizeMode: "tail"
  }, notification.title)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.description,
    onLayout: onTextLayout,
    numberOfLines: textLines == 0 ? null : showMore ? 0 : 2,
    ellipsizeMode: "tail"
  }, notification.excerpt)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.expirySection
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.description
  }, content.product.expiryShort + ": " + formatDate(notification.dateExpires, language)), (titleNeedsExtending || textNeedsExtending) && !showMore && /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    onPress: function onPress() {
      setShowMore(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.description
  }, content.inbox.showMore)), (titleNeedsExtending || textNeedsExtending) && showMore && /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    onPress: function onPress() {
      setShowMore(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.description
  }, content.inbox.showLess)))), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.markAsRead
  }, notification.pac.status === 'new' &&
  /*#__PURE__*/
  // Here is the unread icon
  // Here we need the Mark as read Icon
  _react["default"].createElement(_reactNative.TouchableOpacity, {
    onPress: markAsRead
  }, /*#__PURE__*/_react["default"].createElement(_icons.NewNotification, null)), notification.pac.status !== 'new' && /*#__PURE__*/_react["default"].createElement(_icons.ReadNotification, null)));
}
var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.subtle,
    elevation: 8
  }, _styles.shadows.shadowByElevation(8)),
  body: {
    flex: 1,
    paddingLeft: 12,
    paddingRight: 12,
    paddingVertical: 8,
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  title: _objectSpread(_objectSpread({
    fontSize: 14
  }, _styles.typography.extrabold), {}, {
    color: _styles.colors.exisBlue
  }),
  description: _objectSpread({
    fontSize: 10,
    color: _styles.colors.focus
  }, _styles.typography.medium),
  markAsRead: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 12
  },
  productImage: {
    width: 72,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    backgroundColor: _styles.backgroundColors.srGreen,
    alignItems: 'center',
    justifyContent: 'center'
  },
  expirySection: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});